import React from "react";
import "./Online_degree.css";
import Common_title from "../../common_components/common-title/Common_title";

const Online_degree = () => {
  return (
    <>
      <section className="Online_degree_section">
        <div className="container">
          <Common_title
            className="text-center"
            title="DPU Online Degree Program"
            subtitle="Promotions That Resonate. Emotions That Connect."
          />

          <div className="vdosection">
            <video
              width="600"
              controls
              className="video-holder"  
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="/assets/video/online_degree.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* <iframe
              height="400px"
              className="video-holder"
              src="https://www.youtube.com/embed/OkM5v68Qz74?list=TLGGkHpA1KGLyicxNzExMjAyNQ"
              title="Get a Promotion with DPU Online MBA | DPUCOL - Empowering Education"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Online_degree;
